export type PlatformFlavor = 'mac' | 'other';

const MAC_IDENTIFIERS = ['mac', 'iphone', 'ipad', 'ipod'];

function getNavigatorPlatform(): string {
  if (typeof navigator === 'undefined') {
    return '';
  }

  const navWithUA = navigator as Navigator & {
    userAgentData?: {
      platform?: string;
    };
  };

  const platform = navWithUA.platform ?? navWithUA.userAgentData?.platform;
  return platform?.toLowerCase() ?? '';
}

function getNavigatorUserAgent(): string {
  if (typeof navigator === 'undefined') {
    return '';
  }

  return navigator.userAgent?.toLowerCase?.() ?? '';
}

function isProcessDarwin(): boolean {
  const proc = (globalThis as { process?: { platform?: string } }).process;
  return proc?.platform === 'darwin';
}

/**
 * Detects whether the current runtime platform should use macOS style shortcuts.
 * Falls back to process.platform for test environments that lack navigator.
 */
export function detectPlatform(): PlatformFlavor {
  const navPlatform = getNavigatorPlatform();
  for (const id of MAC_IDENTIFIERS) {
    if (navPlatform.includes(id)) {
      return 'mac';
    }
  }

  const userAgent = getNavigatorUserAgent();
  for (const id of MAC_IDENTIFIERS) {
    if (userAgent.includes(id)) {
      return 'mac';
    }
  }

  if (isProcessDarwin()) {
    return 'mac';
  }

  return 'other';
}

export function isMacPlatform(): boolean {
  return detectPlatform() === 'mac';
}
